// Generated by CoffeeScript 2.7.0
var GeneratePushPackageSidebar;

import EditPushPackageModal from 'trunks/vue/admin/compositions/push_package/push_package_modal/edit_push_package_modal.js';

import PushPackageTab from './push_package_sidebar/push_package_tab.js';

import PushPackageListItem from './push_package_sidebar/push_package_list_item.js';

export var PushPackageSidebar = Vue.extend({
  components: {
    'push-package-tab': PushPackageTab,
    'push-package-list-item': PushPackageListItem
  },
  props: {
    defaultTab: {
      type: String,
      default: 'user'
    },
    initialSelectedId: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      selectedId: this.initialSelectedId,
      pushPackageOptions: [],
      activeTab: this.defaultTab,
      scrollTop: 0
    };
  },
  template: `<div class="sidebar-push-package" push-package-has-navigator>
  <push-package-tab :initialActiveTab='defaultTab'
                    @tabChanged="tabChangedFunc" />
  <div class="list">
    <div class="list-head">
      <button class="text-btn btn-primary"
              @click="openPushPackageModalFunc">
        <i class="slp-plus-circle"></i>
        <span>{{ textOption.add }}</span>
      </button>
    </div>
    <div class="list-content"
         v-if='pushPackageOptions.length'
         @scroll="sidebarScrollFunc"
         ref="sidebarContentRef">
      <push-package-list-item v-for='pushPackage in pushPackageOptions'
                              :pushPackage='pushPackage'
                              :key='pushPackage.id'
                              :selectedId='selectedId'
                              :resourceUrl='resourceUrl'
                              :editModalTitle='textOption.edit'
                              @deletedPushPackage='deletedPushPackageFunc'
                              @selectedPushPackageChange='selectedPushPackageChangeFunc'
                              @pushPackageChanged='pushPackageChangedFunc' />
    </div>
    <div class="list-content" v-else>
      <div class="no-data">{{ textOption.noData }}</div>
    </div>
  </div>
</div>`,
  watch: {
    resourceUrl: {
      handler: function() {
        return this.doRequest();
      },
      immediate: true
    },
    selectedId: function(val) {
      if (val) {
        return Turbolinks.visit(`${this.resourceUrl}/${this.selectedId}`);
      } else {
        return Turbolinks.visit(this.resourceUrl);
      }
    },
    activeTab: function() {
      return Turbolinks.visit(this.resourceUrl);
    }
  },
  computed: {
    textOption: function() {
      if (this.activeTab === 'user') {
        return {
          add: '新增自定义推送包',
          edit: '编辑自定义推送包',
          noData: '暂无自定义推送包'
        };
      } else {
        return {
          add: '新增标准推送包',
          edit: '编辑标准推送包',
          noData: '暂无标准推送包'
        };
      }
    },
    doRequestUrl: function() {
      if (this.activeTab === 'user') {
        return Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resourceUrl, {
          type: 'user'
        });
      } else {
        return this.resourceUrl;
      }
    },
    resourceUrl: function() {
      if (this.activeTab === 'user') {
        return "/admin/push_packages";
      } else {
        return "/admin/settings/push_packages";
      }
    }
  },
  methods: {
    doRequest: function() {
      return Skylark.Libs.Ajax.get(this.doRequestUrl, {
        responseType: 'json',
        success: (data) => {
          var ref;
          this.pushPackageOptions = data;
          return this.selectedId = (ref = this.pushPackageOptions[0]) != null ? ref.id : void 0;
        }
      });
    },
    tabChangedFunc: function(tab) {
      return this.activeTab = tab;
    },
    selectedPushPackageChangeFunc: function(id) {
      return this.selectedId = id;
    },
    pushPackageChangedFunc: function(pushPackage) {
      _.find(this.pushPackageOptions, function(option) {
        var flag;
        flag = option.id === pushPackage.id;
        if (flag) {
          _.extend(option, pushPackage);
        }
        return flag;
      });
      return Turbolinks.visit();
    },
    openPushPackageModalFunc: function() {
      return new EditPushPackageModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-push-package-modal'),
        propsData: {
          title: this.textOption.add,
          callback: (pushPackage) => {
            return this.addPushPackageFunc(pushPackage);
          }
        }
      });
    },
    addPushPackageFunc: function(pushPackage) {
      return Skylark.Libs.Ajax.post(this.resourceUrl, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          push_package: pushPackage
        },
        success: (data) => {
          this.pushPackageOptions.push(data);
          return Skylark.Bridge.newAlertify('新增成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, errors) {
          return Skylark.Bridge.newAlertify(errors.join('，'), {
            type: 'error'
          });
        }
      });
    },
    deletedPushPackageFunc: function(pushPackage) {
      var ref;
      this.pushPackageOptions = _.reject(this.pushPackageOptions, function(option) {
        return option.id === pushPackage.id;
      });
      if (this.selectedId === pushPackage.id) {
        return this.selectedId = (ref = this.pushPackageOptions[0]) != null ? ref.id : void 0;
      }
    },
    sidebarScrollFunc: function(e) {
      return this.scrollTop = e.target.scrollTop;
    },
    _setSidebarScrollTop: function() {
      if (this.$refs.sidebarContentRef) {
        return this.$refs.sidebarContentRef.scrollTop = this.scrollTop;
      }
    }
  }
});

export default GeneratePushPackageSidebar = {
  _generatePushPackageSidebar: function(activeTab, initialSelectedId) {
    var navigator_el;
    navigator_el = DomMaster.find('[push-package-has-navigator]');
    this.sidebarVm = navigator_el.isPresent() ? navigator_el.node.__vue__ : new PushPackageSidebar({
      el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('push_package_sidebar'),
      propsData: {
        defaultTab: activeTab,
        initialSelectedId: initialSelectedId
      }
    });
    return this.sidebarVm._setSidebarScrollTop();
  }
};
